import * as DataUtils from './DataUtils.js';
import { ListaPartidos } from '../constantes/Filtros.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as TipoRival from '../constantes/TipoRival.js';

const TipoURL = {
  RIVALES: 'rivales',
  TOTALES: 'totales',
  CANTIDAD: 'cantidad',
  LISTA: 'lista',
};

export const GetPrefijo = (tipoCompetidor) => {
  switch (tipoCompetidor) {
    case TipoEquipo.CLUB:
      return 'clubes';
    case TipoEquipo.SELECCION:
      return 'selecciones_pais';
    default:
      return '';
  }
};

export const GetRivales = async (
  tipoHistorial,
  idCompetidor,
  tipoRival,
  categoria,
  tipoInternacional
) => {
  if (!idCompetidor || !categoria?.id) return [];
  let url =
    PathBaseHistorial(tipoHistorial, idCompetidor, tipoRival) + '?categoria=' + categoria.id;
  if (tipoInternacional?.id) {
    url += `&tipoInternacional=${tipoInternacional.id}`;
  }
  return DataUtils.FetchLista(url);
};

export const GetTotalesRivales = async (
  tipoHistorial,
  idCompetidor,
  tipoRival,
  categoria,
  tipoInternacional
) => {
  if (!idCompetidor || !categoria?.id) return [];
  let url =
    PathBaseHistorial(tipoHistorial, idCompetidor, tipoRival) +
    '/totales?categoria=' +
    categoria.id;
  if (tipoInternacional?.id) {
    url += `&tipoInternacional=${tipoInternacional.id}`;
  }
  return DataUtils.FetchLista(url);
};

export const GetCantidadPartidos = async (
  urlBase,
  idItem,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  const url = URLCantPartidos(urlBase, idItem, filtro, idCategoria, tipoInternacional);
  return url ? DataUtils.FetchObject(url) : 0;
};

export const GetCantidadPartidosClub = async (idClub, filtro, idCategoria) => {
  return GetCantidadPartidos('clubes', idClub, filtro, idCategoria, null);
};

export const GetCantidadPartidosEstadio = async (
  idEstadio,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  return GetCantidadPartidos('estadios', idEstadio, filtro, idCategoria, tipoInternacional);
};

export const GetCantidadPartidosArbitro = async (
  idPersona,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  return GetCantidadPartidos('personas_arbitro', idPersona, filtro, idCategoria, tipoInternacional);
};

export const GetCantidadPartidosJugador = async (
  idPersona,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  return GetCantidadPartidos('jugadores', idPersona, filtro, idCategoria, tipoInternacional);
};

export const GetCantidadPartidosPersona = async (
  idPersona,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  return GetCantidadPartidos('personas', idPersona, filtro, idCategoria, tipoInternacional);
};

export const GetCantidadPartidosTecnico = async (
  idPersona,
  filtro,
  idCategoria,
  tipoInternacional
) => {
  return GetCantidadPartidos('tecnicos', idPersona, filtro, idCategoria, tipoInternacional);
};

export const PathBaseHistorial = (tipoHistorial, idCompetidor, tipoRival) => {
  let path = null;
  switch (tipoHistorial) {
    case TipoEquipo.CLUB:
      path = 'clubes/' + idCompetidor + '/rivales/';
      break;
    case TipoEquipo.SELECCION:
      path = 'selecciones_pais/' + idCompetidor + '/rivales/';
      break;
    default:
      return null;
  }
  switch (tipoRival) {
    case TipoRival.CLUB:
      path += 'clubes';
      break;
    case TipoRival.EQUIPO:
      path += 'equipos';
      break;
    case TipoRival.SELECCION:
      path += 'selecciones';
      break;
    default:
      return null;
  }
  return path;
};

const URLPartidos = (
  item,
  id,
  filtro,
  tipoURL,
  pagina,
  cantItems,
  idCategoria,
  tipoInternacional
) => {
  let url = item + '/' + id + '/partidos';
  let separador = '?';
  if (filtro !== null && Number(filtro) === ListaPartidos.AMISTOSOS) {
    url += '/amistosos';
  }
  if (tipoURL === TipoURL.CANTIDAD) {
    url += '/cantidad';
  } else if (tipoURL === TipoURL.TOTALES) {
    url += '/totales';
  }
  if (idCategoria != null) {
    url += separador + 'categoria=' + idCategoria;
    separador = '&';
  }
  if (filtro !== null && filtro > 0) {
    url += separador + 'agrupacion=' + filtro;
    separador = '&';
  }
  if (tipoURL === TipoURL.LISTA) {
    url += separador + 'pagina=' + pagina + '&items=' + cantItems;
    separador = '&';
  }
  if (tipoInternacional) {
    url += separador + 'tipoInternacional=' + tipoInternacional;
    separador = '&';
  }
  if (filtro !== null && filtro < 0) {
    if (filtro === ListaPartidos.OFICIALES) {
      url += separador + 'oficial=true';
      separador = '&';
    } else if (filtro === ListaPartidos.NO_OFICIALES) {
      url += separador + 'oficial=false';
      separador = '&';
    }
  }
  return url;
};

export const URLCantPartidos = (item, id, filtro, idCategoria, tipoInternacional) => {
  return URLPartidos(
    item,
    id,
    filtro,
    TipoURL.CANTIDAD,
    null,
    null,
    idCategoria,
    tipoInternacional
  );
};

export const URLListaPartidos = (
  item,
  id,
  filtro,
  pagina,
  cantItems,
  idCategoria,
  tipoInternacional
) => {
  return URLPartidos(
    item,
    id,
    filtro,
    TipoURL.LISTA,
    pagina,
    cantItems,
    idCategoria,
    tipoInternacional
  );
};

export const URLTotalesPartidos = (item, id, filtro, idCategoria, tipoInternacional) => {
  return URLPartidos(item, id, filtro, TipoURL.TOTALES, null, null, idCategoria, tipoInternacional);
};
